import React, { ReactElement } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Grid,
  GridRow,
  GridColumn,
  Loader,
} from "@screencloud/screencloud-ui-components";

import StreamList from "../StreamList/StreamList";

import CreateStreamLogo from "../../assets/create-stream-logo.svg";
import "./StreamSelection.scss";
import { startCreate } from "../../actions";
import { EditorStore } from "../../types";
import { RootState } from "../../reducers";

const STREAM_SELECTION_LABELS = {
  CHOOSE_A_STREAM: "Choose a Streaming Channel",
  OR_SET_UP_STREAM: "or set up a new one",
  SETUP_NEW_STREAM_BTN: "Set up a new Streaming Channel",
  DESCRIPTION: "You can always rename or delete previous Streaming Channels",
};

const StreamSelection = (): ReactElement<void> => {
  const dispatch = useDispatch();
  const editor: EditorStore = useSelector((state: RootState) => state.editor);

  return (
    <GridRow className="stream-selection-grid">
      <GridColumn
        className={
          "sixteen wide mobile twelve wide tablet twelve wide computer"
        }
      >
        <Grid className="stream-selection-table-grid" centered>
          <GridRow>
            <GridColumn
              className={
                "sixteen wide mobile eleven wide tablet eleven wide computer"
              }
            >
              <div className={"stream-selection_header_selection-text"}>
                <span className={"primary-lbl"}>
                  {STREAM_SELECTION_LABELS.CHOOSE_A_STREAM}
                </span>
                <span className={"secondary-lbl"}>
                  {STREAM_SELECTION_LABELS.OR_SET_UP_STREAM}
                </span>
              </div>
            </GridColumn>
          </GridRow>
          <GridRow>
            <GridColumn
              className={
                "sixteen wide mobile eleven wide tablet eleven wide computer"
              }
            />
          </GridRow>
          <GridRow>
            <GridColumn
              className={
                "sixteen wide mobile eleven wide tablet eleven wide computer"
              }
            >
              <StreamList />
            </GridColumn>
          </GridRow>
        </Grid>
      </GridColumn>
      <GridColumn
        className={
          "stream-creation-sidebar sixteen wide mobile four wide tablet four wide computer"
        }
      >
        <div className="stream-creation-sidebar-container">
          <div className={"stream-list_rows_row_name_logo"}>
            <img
              className={"live-stream-icon"}
              src={CreateStreamLogo}
              alt="Logo"
            />
          </div>

          <Button outline="true" onClick={() => dispatch(startCreate())}>
            <div>
              {editor.createLoading ? (
                <Loader
                  inline="centered"
                  active
                  size="medium"
                  className="createLoader"
                />
              ) : (
                <span>{STREAM_SELECTION_LABELS.SETUP_NEW_STREAM_BTN}</span>
              )}
            </div>
          </Button>

          <div className="create-stream-description">
            <em>{STREAM_SELECTION_LABELS.DESCRIPTION}</em>
          </div>
        </div>
      </GridColumn>
    </GridRow>
  );
};

export default StreamSelection;
